module.exports = __webpack_public_path__ + "img/performance.7ffc53f1.png";